import { numberAttributeAccessor } from "react-migration/domains/constraints/designation/util/numberAttributeAccessor";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Insight } from "react-migration/components/Insight/Insight";
import { HousingCategory, HOUSING_COLOURS } from "./constants";
import { GbpPerArea } from "./GbpPerArea";

interface HousingPricePerSqMeterInsightProps {
  designation: SingleDesignation;
  housingType: HousingCategory;
  priceAttributeKey: string;
  lpaPriceAttributeKey: string;
}

export function HousingPricePerSqMeterInsight({
  designation,
  housingType,
  priceAttributeKey,
  lpaPriceAttributeKey,
}: HousingPricePerSqMeterInsightProps) {
  const { t } = useTranslation();
  const price = numberAttributeAccessor(designation, priceAttributeKey);
  const lpaPrice = numberAttributeAccessor(designation, lpaPriceAttributeKey);

  return (
    <Insight.Wrapper
      title={
        <div className="flex gap-x-1 items-center">
          <div
            className="w-3 h-3 rounded-full"
            style={{ background: HOUSING_COLOURS[housingType as HousingCategory] }}
          />
          {t(`workbench.summary.local_market_value.type.${housingType}`)}
        </div>
      }
    >
      <Insight.Body>
        <GbpPerArea
          gbpPerSqMeter={price}
          unitClassNames="ml-1 self-start leading-6 text-sm font-medium text-text-base-secondary-a"
        />
      </Insight.Body>
      <Insight.Footer description={<GbpPerArea gbpPerSqMeter={lpaPrice} />}>LPA rate</Insight.Footer>
    </Insight.Wrapper>
  );
}
